// System Features Mutations

export const setSystemMenu = (state, payload) => {
  state.systemMenu = payload
}
